/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DecisionEnum } from './DecisionEnum';
import {
    DecisionEnumFromJSON,
    DecisionEnumFromJSONTyped,
    DecisionEnumToJSON,
    DecisionEnumToJSONTyped,
} from './DecisionEnum';

/**
 * Serializer to create the decision taken for an unmatched data point.
 * @export
 * @interface UnmatchedDataPointDecision
 */
export interface UnmatchedDataPointDecision {
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecision
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecision
     */
    dataPoint: string;
    /**
     * 
     * @type {DecisionEnum}
     * @memberof UnmatchedDataPointDecision
     */
    decision: DecisionEnum;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecision
     */
    site?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecision
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedDataPointDecision
     */
    readonly emissionRecordId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedDataPointDecision
     */
    readonly processedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedDataPointDecision
     */
    readonly createdAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof UnmatchedDataPointDecision
     */
    readonly updatedAt: Date | null;
}



/**
 * Check if a given object implements the UnmatchedDataPointDecision interface.
 */
export function instanceOfUnmatchedDataPointDecision(value: object): value is UnmatchedDataPointDecision {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('dataPoint' in (value as Record<string, any>)) && !('data_point' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataPoint'] === undefined && (value as Record<string, any>)['data_point'] === undefined)) return false;
    if (!('decision' in value) || value['decision'] === undefined) return false;
    if ((!('emissionRecordId' in (value as Record<string, any>)) && !('emission_record_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionRecordId'] === undefined && (value as Record<string, any>)['emission_record_id'] === undefined)) return false;
    if ((!('processedAt' in (value as Record<string, any>)) && !('processed_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['processedAt'] === undefined && (value as Record<string, any>)['processed_at'] === undefined)) return false;
    if ((!('createdAt' in (value as Record<string, any>)) && !('created_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['createdAt'] === undefined && (value as Record<string, any>)['created_at'] === undefined)) return false;
    if ((!('updatedAt' in (value as Record<string, any>)) && !('updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['updatedAt'] === undefined && (value as Record<string, any>)['updated_at'] === undefined)) return false;
    return true;
}

export function UnmatchedDataPointDecisionFromJSON(json: any): UnmatchedDataPointDecision {
    return UnmatchedDataPointDecisionFromJSONTyped(json, false);
}

export function UnmatchedDataPointDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnmatchedDataPointDecision {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataPoint': json['data_point'],
        'decision': DecisionEnumFromJSON(json['decision']),
        'site': json['site'] === undefined ? undefined : json['site'] === null ? null : json['site'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'emissionRecordId': json['emission_record_id'],
        'processedAt': (json['processed_at'] == null ? null : new Date(json['processed_at'])),
        'createdAt': (json['created_at'] == null ? null : new Date(json['created_at'])),
        'updatedAt': (json['updated_at'] == null ? null : new Date(json['updated_at'])),
    };
}

export function UnmatchedDataPointDecisionToJSON(json: any): UnmatchedDataPointDecision {
    return UnmatchedDataPointDecisionToJSONTyped(json, false);
}

export function UnmatchedDataPointDecisionToJSONTyped(value?: Omit<UnmatchedDataPointDecision, 'id'|'emissionRecordId'|'processedAt'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data_point': value['dataPoint'],
        'decision': DecisionEnumToJSON(value['decision']),
        'site': value['site'],
        'notes': value['notes'],
    };
}

